module.exports = __webpack_public_path__ + "static/media/gallery13.485c5ee9.jpg";